module.exports = __webpack_public_path__ + "img/icon_trade_yuyue.9d65b88a.png";